import Header from "../components/header";
import { DialogEnum, useDialog } from "../contexts/DialogContext";
import { RoutePaths } from "../routes";

export default function Landing() {
  const dialog = useDialog();

  return (
    <>
      <Header>
        <div className="my-12 mx-auto font-poppins">
          <div className="max-w-2xl mx-auto text-white text-center text-4xl md:text-6xl font-semibold px-6 leading-tight">
            Full color charts are just a{" "}
            <span style={{ borderBottom: "5px solid red" }}>click</span> away.
          </div>
          <div className="mt-10 max-w-md mx-auto text-white text-center text-xl leading-8">
            With BallotChart you can produce the charts you need in a matter of
            minutes.
          </div>
          <div className="flex justify-center mt-8">
            <a
              href={RoutePaths.CREATE_ACCOUNT}
              className="bg-white text-blue-700 py-3 px-6 rounded-md tracking-wider uppercase font-semibold transition hover:text-blue-800"
            >
              Sign Up Today
            </a>
          </div>
        </div>
      </Header>
      <div className="mt-10 mx-auto max-w-7xl container">
        <div className="grid grid-cols-1 place-items-center xl:place-items-stretch xl:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg h-[340px] w-[360px] xl:w-auto flex flex-col justify-start items-center shadow-xl">
            <div
              className="h-[120px] w-1/2 -ml-[48px] mt-10"
              style={{
                backgroundImage: "url('/landing/fast.svg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
            <div className="uppercase text-blue-900 font-semibold text-2xl mt-5">
              Fast
            </div>
            <div className="text-center mt-2 text-lg font-normal max-w-[250px] font-sourceSansPro">
              <span className="font-semibold">Within minutes</span> you can
              produce full color charts.
            </div>
          </div>
          <div className="bg-white rounded-lg h-[340px] w-[360px] xl:w-auto flex flex-col justify-start items-center shadow-xl">
            <div
              className="h-[120px] w-[117px] mt-10 rounded-md"
              style={{
                backgroundColor: "#E6EBF5",
                backgroundImage: "url('/landing/simple.svg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "80%",
              }}
            />
            <div className="uppercase text-blue-900 font-semibold text-2xl mt-5">
              Simple
            </div>
            <div className="text-center mt-2 text-lg font-normal max-w-[250px] font-sourceSansPro">
              <span className="font-semibold">Follow the ballot,</span> input
              name, number of candidates, number of write-ins, and the vote for.
            </div>
          </div>
          <div className="bg-white rounded-lg h-[340px] w-[360px] xl:w-auto flex flex-col justify-start items-center shadow-xl">
            <div
              className="h-[120px] w-[117px] mt-10"
              style={{
                backgroundImage: "url('/landing/accurate.svg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
            <div className="uppercase text-blue-900 font-semibold text-2xl mt-5">
              Fast
            </div>
            <div className="text-center mt-2 text-lg font-normal max-w-[250px] font-sourceSansPro">
              Follows Michigan’s Promulgated Rules and is{" "}
              <span className="font-semibold">always accurate!</span>
            </div>
          </div>
        </div>
        <div
          className="mt-10 mb-[100px] w-full h-[420px] flex justify-end rounded-lg overflow-hidden"
          style={{
            backgroundImage: "url('/landing/liberty.png')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left",
            backgroundSize: "cover",
          }}
        >
          <div className="bg-blue-100 w-full md:w-[50%] xl:w-[34%] p-[50px] flex flex-col justify-between items-center md:items-start">
            <div>
              <div className="flex items-end">
                <div className="relative h-[50px] w-[50px]">
                  <div
                    className="absolute h-[50px] w-[50px] top-0"
                    style={{
                      backgroundImage: "url('/landing/box.svg')",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  />
                  <div
                    className="absolute h-[80px] w-[70px] left-[2px] top-[-36px]"
                    style={{
                      backgroundImage: "url('/landing/check.svg')",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  />
                </div>
                <div className="ml-4 text-blue-800 font-semibold text-5xl ">
                  $45.00
                </div>
              </div>
              <div className="ml-[68px] text-gray-500 font-sourceSansPro text-2xl">
                first chart
              </div>
            </div>
            <div>
              <div className="flex items-end">
                <div className="relative h-[50px] w-[50px]">
                  <div
                    className="absolute h-[50px] w-[50px] top-0"
                    style={{
                      backgroundImage: "url('/landing/box.svg')",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  />
                  <div
                    className="absolute h-[80px] w-[70px] left-[2px] top-[-36px]"
                    style={{
                      backgroundImage: "url('/landing/check.svg')",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  />
                </div>
                <div className="ml-4 text-blue-800 font-semibold text-5xl ">
                  $25.00
                </div>
              </div>
              <div className="ml-[68px] text-gray-500 font-sourceSansPro text-2xl">
                each additional chart
              </div>
            </div>
            <div>
              <button
                className="uppercase py-3 px-6 text-blue-800 outline outline-1 outline-blue-800 font-semibold tracking-wider rounded-md mr-5 transition hover:text-blue-900 hover:outline-blue-900"
                onClick={() => dialog.push(DialogEnum.SIGN_IN)}
              >
                Log In
              </button>
              <a
                className="uppercase py-3 px-5 text-white bg-blue-800 rounded-md font-semibold tracking-wider transition hover:bg-blue-900"
                href={RoutePaths.CREATE_ACCOUNT}
              >
                Sign Up
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
